import { useSelector } from 'react-redux';

/**
 * Custom hook to check if the current user has a specific permission.
 * @returns {Object} { hasPermission }
 */
export const useRolePermission = () => {
    const { permissions, roleName, role, user } = useSelector((state) => state.auth);

    // Top of the role ladder (Admin, super admin, or a role at position 1)
    const seesAllData =
        user?.role === 'super_admin' || roleName?.toLowerCase() === 'admin' || role?.position === 1;

    /**
     * Checks if the user has the required permission for a module and action.
     * @param {string} module - The module name (slug like 'products', 'leads', etc.)
     * @param {string} action - The action name ('view', 'create', 'edit', 'delete', 'export', 'print')
     * @returns {boolean}
     */
    const hasPermission = (module, action) => {
        // Admin has all permissions
        if (permissions?.all === true || roleName?.toLowerCase() === 'admin') {
            return true;
        }

        // Check if the module exists in permissions
        if (permissions && permissions[module]) {
            // If action is NOT provided, it just checks if the module exists in permissions (at least one permission)
            if (!action) {
                return Object.values(permissions[module]).some(val => val === true);
            }
            
            // Check specific action
            return !!permissions[module][action];
        }

        return false;
    };

    return { hasPermission, seesAllData };
};
